import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import authSlice from '../slice/authSlice';
import commonSlice from '../slice/commonSlice';
import roleSlice from '../slice/roleSlice';
import userSlice from '../slice/userSlice';

const rootReducer = combineReducers({
  auth: authSlice,
  common: commonSlice,
  role: roleSlice,
  user: userSlice,
});

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.REACT_APP_NODE_ENV !== 'production',
});

export const persister = persistStore(store);
